import { gql } from "@apollo/client";

export const ATTENDEE_DEMOGRAPHICS = gql`
  query attendeeDemographics($where: attendees_bool_exp) {
    attendees(where: $where, order_by: { created_at: desc }) {
      id
      first_name
      last_name
      email
      phone_number
      event_id
      event {
        id
        name
      }
      is_active
      is_suspended
      created_at
      optional_datas
    }
  }
`;
